export default __webpack_public_path__ + "static/media/medal.74cb0217.svg";